import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';
import { CamKaliteEditComponent } from './cam-kalite-edit.component';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';

const SONUC_RENK: Record<string, string> = { 'Kabul': '#52c41a', 'Koşullu': '#faad14', 'Red': '#ff4d4f' };
const SONUC_RGB: Record<string, string> = { 'Kabul': '82,196,26', 'Koşullu': '250,173,20', 'Red': '255,77,79' };

@Component({
  selector: 'cam-kalite-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--cam-kalite" [style.--accent]="renk()" [style.--accent-rgb]="rgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">🎯 KALİTE KONTROL</div>
        <div class="kk-sonuc-badge" [style.background]="'rgba('+rgb()+',.25)'" [style.color]="renk()" [style.border-color]="'rgba('+rgb()+',.5)'" [style.box-shadow]="'0 0 10px rgba('+rgb()+',.2)'">{{ sonuc() }}</div>
        @if (olcu()) { <div class="kk-olcu">{{ olcu() }}</div> }
        @if (d('kontrolEden')) { <div class="kk-alt">Kontrol: {{ d('kontrolEden') }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? ilerleme() : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .kk-sonuc-badge { display: inline-block; padding: 3px 12px; border-radius: 4px; font-size: 10px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; border: 1.5px solid; margin-top: 4px; backdrop-filter: blur(4px); }
    .kk-olcu { font-size: 10px; color: var(--py-metin-ucuncul, #64748b); font-family: monospace; margin-top: 4px; }
    .kk-alt { font-size: 11px; color: var(--py-metin-ikincil, #94a3b8); margin-top: 2px; }
  `],
})
export class CamKaliteKartComponent extends GameCardBase {
  parametreler = input<any>();
  _hesap = input<any>();
  constructor() { super(); }
  d(ismi: string) { return paramDeger(this.parametreler()?.ek, ismi); }
  sonuc = computed(() => this.d('sonuc') || 'Bekliyor');
  renk = computed(() => SONUC_RENK[this.sonuc()] || '#94a3b8');
  rgb = computed(() => SONUC_RGB[this.sonuc()] || '148,163,184');
  olcu = computed(() => { const v = [this.d('olculenEn'), this.d('olculenBoy'), this.d('olculenYukseklik')].filter(x => x); return v.length ? v.join(' × ') + ' mm' : ''; });
  ilerleme = computed(() => this.sonuc() === 'Kabul' ? 100 : this.sonuc() === 'Koşullu' ? 60 : this.sonuc() === 'Red' ? 0 : 10);
}

@Component({
  selector: 'cam-kalite-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#0891b2">
      <div class="sk-icerik">
        <div class="sk-baslik">🎯 Kalite Kontrol</div>
        @if (olcu()) { <div class="sk-alt" style="font-family:monospace;font-size:10px">{{ olcu() }}</div> }
        @if (d('kontrolEden')) { <div class="sk-alt">{{ d('kontrolEden') }}</div> }
      </div>
      <div class="sk-sag">
        <span class="sk-chip" [style.border-color]="sonucRenk()" [style.color]="sonucRenk()">{{ sonuc() }}</span>
      </div>
    </div>
  `,
})
export class CamKaliteKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  d(alan: string): any { return paramDeger(this.p(), alan); }
  sonuc = computed(() => this.d('sonuc') || 'Bekliyor');
  sonucRenk = computed(() => SONUC_RENK[this.sonuc()] || '#94a3b8');
  olcu = computed(() => { const v = [this.d('olculenEn'), this.d('olculenBoy'), this.d('olculenYukseklik')].filter(x => x); return v.length ? v.join(' × ') + ' mm' : ''; });
}

@DinamikBilesen({
  id: 'cam-kalite',
  baslik: 'Kalite Kontrol',
  aciklama: 'Cam kalite kontrol kaydı',
  ikon: 'safety-certificate',
  kategori: 'cam-isleme',
})
class CamKalite {
  paylas_kutusu = CamKaliteEditComponent;
  paylasilmis_kart = CamKaliteKartComponent;
  paylasilmis_kart_sade = CamKaliteKartSadeComponent;
}
